var _ = function _(t) {
    return t;
  },
  _t;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import { detect } from '../../common/detect';
import { helper } from '../../common/helper';
import * as dayjs from 'dayjs';
import css from './style.pcss';
import { UAParser } from 'ua-parser-js';
var RTLLiveArenaPlayer = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLLiveArenaPlayer, _LitElement);
  function RTLLiveArenaPlayer() {
    var _this;
    _classCallCheck(this, RTLLiveArenaPlayer);
    _this = _callSuper(this, RTLLiveArenaPlayer);
    _this.language = 'lu';
    _this.assetsUrl = 'https://rtl-sites-assets.rtl.lu';
    _this.site = 'rtl';
    _this._player = null;
    _this.test = false;
    _this.isInIframe = window === window.parent ? false : true;
    _this.aiswPlayer = null;
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
      _this.assetsUrl = window.rtlsites.config.assetsUrl;
      _this.site = window.rtlsites.config.site;
      _this.config = window.rtlsites.config;
    }
    _this.location = window.location.origin;
    if (process.env.NODE_ENV == 'development') {
      _this.location = "http://localhost:8080";
    }
    _this.playerLocation = 'https://rtl-sites-assets.rtl.lu';
    if (process.env.NODE_ENV == 'development') {
      _this.playerLocation = 'http://localhost:3000';
    }
    _this.sponsors = null;
    _this.percentBreakpoint = 5;
    _this.lastTime = 0;
    _this.livestreamTimeOffset = 0;
    _this.lastProgress = 0;
    _this.totalViewingTime = 0;
    _this.isAdPlaying = false;
    _this.hasUserInteracted = false;
    _this.wasStartEventSent = false;
    return _this;
  }
  _createClass(RTLLiveArenaPlayer, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _get(_getPrototypeOf(RTLLiveArenaPlayer.prototype), "connectedCallback", this).call(this);

              // ADD JS
              //let sc = document.createElement("script");
              //sc.setAttribute("src", "https://storage.googleapis.com/aisw-assets/player/16.4.5/aisw-player.js");
              //sc.setAttribute("type", "text/javascript");
              //document.head.appendChild(sc);
              _context.next = 3;
              return this._fetchData();
            case 3:
              this.noautoplay = !this.noautoplay;
              _context.next = 6;
              return this.fetchMatchData();
            case 6:
              this.initPlayer();

              // this.sendGoogleEvent();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "fetchMatchData",
    value: function () {
      var _fetchMatchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch(`https://api-gate.rtl.lu/sport/matches/${this.matchid}`).then(function (r) {
                return r.json();
              });
            case 2:
              data = _context2.sent;
              this.matchData = data;
              this.analyticsData = {
                "rtl_mm_channel": "livearena",
                "rtl_content_type": "video",
                "rtl_mm_type": "video",
                "rtl_mm_language": "lb",
                "rtl_livearena_sport": this.matchData.sport.slug,
                "rtl_livearena_competition": this.matchData.competition.slug,
                "rtl_livearena_competition_season": this.matchData.competition.season_id,
                "rtl_livearena_round": this.matchData.round.name,
                "rtl_livearena_match": `${this.matchData.id}`,
                "rtl_livearena_home": this.matchData.home_team.slug,
                "rtl_livearena_visitor": this.matchData.visitor_team.slug,
                "rtl_mm_broadcast_id": "urn:rtl:livearena:" + this.matchData.id,
                "rtl_mm_broadcast_title": `${this.matchData.date} ${this.matchData.hour} ${this.matchData.competition.slug} ${this.matchData.home_team.slug} VS ${this.matchData.visitor_team.slug}`,
                "rtl_mm_broadcast_start_ts": dayjs(`${this.matchData.date} ${this.matchData.hour}`).format()
              };
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchMatchData() {
        return _fetchMatchData.apply(this, arguments);
      }
      return fetchMatchData;
    }()
  }, {
    key: "calculateMODTotalTimeWatched",
    value: function calculateMODTotalTimeWatched(player) {
      var timeWatchedAll = 0;
      for (var i = 0; i < player.played.length; i++) {
        var timeWatched = (player.played.end(i) - player.played.start(i)).toFixed(2);
        timeWatchedAll = Number(timeWatchedAll) + Number(timeWatched);
      }
      return timeWatchedAll;
    }
  }, {
    key: "sendGoogleEvent",
    value: function sendGoogleEvent(event) {
      var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var sendData = _objectSpread(_objectSpread({}, this.analyticsData), additionalData);

      // console.log("THIS AISW", this.aiswPlayer);

      if (!this.aiswPlayer) return;
      var isLive = !isFinite(this.aiswPlayer.duration);
      if (["rtl_player_play", "rtl_player_pause"].includes(event) && !isLive) {
        sendData["rtl_mm_mod_current_time"] = Math.floor(this.aiswPlayer.currentTime);
      }

      // console.log("SENDING " + event + " data: ", sendData)
      // console.log(JSON.stringify(sendData))

      // if (this.isInIframe) {
      //     let postData = {
      //         event: event,
      //         data: sendData
      //     }
      //     // console.log("Sending postmessage", postData)
      //     window.parent.postMessage(
      //         { type: 'analytics', data: postData },
      //         '*'
      //     );
      // }

      window.sendToGoogleAnalytics(sendData, event);
    }
  }, {
    key: "initPlayer",
    value: function initPlayer() {
      var _this2 = this;
      if (!this.match) return;
      //console.log("initPlayer", this.sponsors)
      var poster = `${this.assetsUrl}/images/sport/live-arena/poster_player.jpg?v=1`;
      if (this.match.live_arena_thumbnail_hq) poster = this.match.live_arena_thumbnail_hq;
      var urlParams = helper.getAllUrlParams();
      var vastURL = "https://dokkan.ipdigital.lu/rtlsportlivearena/livearena_vmap_Adnuntius_SmartX.php";
      if (this.test) {
        vastURL = "https://dokkan.ipdigital.lu/rtlsportlivearena/livearena_vmap_SmartX.php";
      }
      vastURL += `?type=${encodeURIComponent(this.match.sport.slug)}`;
      vastURL += `&competition=${encodeURIComponent(this.match.competition.slug)}`;
      vastURL += `&competitionDay=${encodeURIComponent(this.match.round.name)}`;
      vastURL += `&teamHome=${encodeURIComponent(this.match.home_team.slug)}`;
      vastURL += `&teamVisitor=${encodeURIComponent(this.match.visitor_team.slug)}`;

      // Levels
      var pathFiltered = window.location.pathname.substr(1).split("\/").filter(function (item) {
        return item != '' && item.indexOf(".html") == -1;
      });
      for (var i = 1; i <= pathFiltered.length; i++) {
        vastURL += `&${window.rtlsites.config.site}-level${i}=${encodeURIComponent(pathFiltered[i - 1])}`;
      }
      vastURL += `&isApp=${this.config.isApp}`;
      var bp = detect.getCurrentBreakpoint();
      if (this.config.isApp) {
        if (this.config.device == "t" || this.config.device == "p") {
          vastURL += "&device=app_tablet";
        } else {
          vastURL += "&device=app_phone";
        }
      } else {
        if (bp.id === "tablet") vastURL += "&device=tablet";else if (bp.id === "mobile") vastURL += "&device=mobile";else {
          vastURL += "&device=desktop";
        }
      }

      // IPL Client
      if (urlParams.client) vastURL += `&client=${urlParams.client}`;

      // Adnuntius
      if (window.rtlsites.config.ipDigId) {
        vastURL += `&usi=${window.rtlsites.config.ipDigId.id}`;
        vastURL += `&sessionId=${window.rtlsites.config.ipDigId.session}`;
      }
      if (didomiState.didomiIABConsent) vastURL += `&consentString=${didomiState.didomiIABConsent}`;
      if (didomiState.didomiGDPRApplies) vastURL += `&gdpr=${didomiState.didomiGDPRApplies}`;
      if (window.rtlsites.config.debug) vastURL += `&debug=${window.rtlsites.config.debug}`;
      var options = {
        gameId: this.match.live_arena_id,
        brand: `${this.assetsUrl}/images/sport/live-arena/widget_logo.svg?`,
        speaker: dayjs(this.match.date).isAfter(dayjs('2022-08-01')),
        chat: false,
        login: false,
        poster: poster,
        vastUrl: vastURL,
        allowLinear: true,
        allowNonLinear: true,
        allowSponsor: true,
        autoplay: false,
        sponsors: this.sponsors,
        media: false,
        embed: false,
        enableMoreMedia: false,
        overlayInfo: true
        // Possible and default options:
        // // one of the following must always be provided
        // videoUrl!: string // simple video path (can be hls)
        // gameId?: string  // soccerwatch game id
        // // optional when gameId is provided
        // // not supported when videoUrl is provided
        // // defines if the player should play the full time video or the highlight cut
        // playNow?: VideoTypes // default: video
        // // VR or classical video, default 'video'
        // presentationType?: PresentationType
        //
        // // optional language files, en / de are already contained
        // // language.json file needs id as name
        // // e.g.: fr -> [path]/fr.json
        // languages!: string[]
        //
        // // optional default language id
        // // default en
        // defaultLanguage?: string
        //
        // // optional, vast url
        // vastUrl?: string
        //
        // // optional player options
        // poster?: string
        // autoplay?: boolean // default: false
        // seekTime = 0
        // volume?
        //
        // // optional vr url
        // vrUrl?: string
        //
        // // optional highlight url
        // highlightUrl?: string
        //
        // // used when playNow === 'custom'
        // customDescription?: string
        //
        // // enables or disables single features
        // overlayControl?: boolean // default: true
        // overlayInfo?: boolean // default: true
        // overlayBigButton?: boolean // default: true
        // vrAllowed?: boolean // default: false
        // speaker?: boolean // default: false
        // recorder?: boolean
        // lazy?: boolean
        // login?: boolean
        // chat?: boolean
        // media?: boolean
        // embed?: boolean
        // events?: boolean
        // enableFullscreen?: boolean
        // forceFullscreenButton?: boolean
        // ios?: boolean
        // brand?: string
        // timeBarMarker?: boolean
        // cookies?: boolean
        // enableCoaching?: boolean
        // inPlaylist?: boolean
        // // standalone?: boolean
        // enableDrawing?: boolean
        //
        // // optional granular hls config
        // // ref https://github.com/video-dev/hls.js/blob/master/docs/API.md
        // hlsConfig?: HlsConfig
        //
        // sponsors?: {inSummaryElement: GenericAd[], inStreamElement: GenericAd[]}
        // playlist?: VideoDataWithRefs[]
        // playlistIndex?: number
        // maxStackedAds = 100
        // callAs = 'anon'
        // paywallFree = false
        // adFree = false
        // allowLinear = true
        // allowNonLinear = true
        // allowSponsor = true
      };
      var playerContainer = document.getElementById('player-container');
      this._player = document.createElement('aisw-player');
      this._player.id = 'aiswplayer';
      this._player.options = options;
      // let firstCall = true;
      this._player.addEventListener('hello', function (event) {
        // if (!firstCall) return;
        // firstCall = false;
        var aisw = event.detail;
        console.log("AISW", aisw);
        aisw.vastRollStarted.subscribe(function (e) {
          _this2.isAdPlaying = true;
          console.log("LIVE vast start", e);
        });
        aisw.vastRollEnded.subscribe(function (e) {
          _this2.isAdPlaying = false;
          console.log("LIVE vast end", e);
          if (!_this2.wasStartEventSent) {
            // if an AD played first, he won't go into the "play" event again, so we have to fake those events here
            _this2.sendGoogleEvent("rtl_player_start");
            _this2.sendGoogleEvent("rtl_player_play");
            _this2.hasUserInteracted = true;
            _this2.wasStartEventSent = true;
          }
        });
        aisw.loadedmetadata.subscribe(function (event) {
          //TODO: sie executen loadedmetadata virum playen..
          console.log("LIVE loadedmetadata", _this2.isAdPlaying);
          _this2.aiswPlayer = event.target;
          window.player = event.target;
          // this.hasUserInteracted = true;

          // if (this.isAdPlaying) return;

          // this.sendGoogleEvent("rtl_player_start");
        });
        aisw.timeupdate.subscribe(function (event) {
          if (_this2.isAdPlaying) return;
          var player = event.target;
          _this2.handleProgressEvent(player);
        });
        aisw.play.subscribe(function (event) {
          console.log("LIVE play", _this2.isAdPlaying);
          if (_this2.isAdPlaying) {
            return;
          }
          if (!_this2.isAdPlaying && !_this2.hasUserInteracted && !_this2.wasStartEventSent) {
            _this2.hasUserInteracted = true;
            _this2.wasStartEventSent = true;
            _this2.sendGoogleEvent("rtl_player_start");
          }
          _this2.sendGoogleEvent("rtl_player_play", _this2.analyticsData);
        });
        aisw.pause.subscribe(function (event) {
          if (_this2.isAdPlaying) {
            return;
          }
          _this2.sendGoogleEvent("rtl_player_pause", _this2.analyticsData);
        });
        window.addEventListener("unload", function (e) {
          console.error("unload triggered", e, _this2.hasUserInteracted);
          if (!_this2.hasUserInteracted) return;
          var timeWatchedAll = _this2.calculateMODTotalTimeWatched(player);
          console.log("AM Unload", timeWatchedAll);
          var newData = _objectSpread({}, _this2.analyticsData);
          newData["rtl_mm_watch_time"] = Math.round(timeWatchedAll);
          if (timeWatchedAll) {
            var percentageWatched = Math.round(timeWatchedAll / player.duration * 100);
            [90, 75, 50, 25, 10, 0].some(function (percentage) {
              if (percentageWatched >= percentage) {
                percentageWatched = percentage;
                return true;
              }
              return false;
            });
            newData["rtl_mm_watch_progress"] = `${percentageWatched}`;
          }
          _this2.sendGoogleEvent("rtl_player_end", _this2.enrichDataWithWatchtime(newData, player, "rtl_player_end"));
        });
        aisw.fullscreenEnter.subscribe(_this2._fullscreenEnterEvent);
        aisw.fullscreenExit.subscribe(_this2._fullscreenExitEvent);
      });
      if (window.rtlsites.config.isIosApp) {
        console.log("AISW PLAYER", "Setting IOS to true");
        this._player.ios = true;
      }
      playerContainer.append(this._player);
    }
  }, {
    key: "handleProgressEvent",
    value: function handleProgressEvent(player) {
      // console.log("PROGRESS", player.duration, isFinite(player.duration))

      var isLive = !isFinite(player.duration);

      // if (player.ads.playing) return;
      if (this.isAdPlaying) {
        return;
      }
      var secondsBreakpoint = 30;
      if (player.currentTime > this.lastTime) {
        this.totalViewingTime += player.currentTime - this.lastTime;
      }
      this.lastTime = player.currentTime;

      // Livestream also all 30s een playing event
      if (isLive) {
        if (this.livestreamTimeOffset === 0) {
          this.livestreamTimeOffset = player.currentTime;
        }
        var timeOffset = this.livestreamTimeOffset;
        var _progress = player.currentTime - timeOffset;

        // console.log("handleProgressEvent", progress, this.lastProgress, this.analyticsData)

        if (_progress >= this.lastProgress + secondsBreakpoint) {
          this.lastProgress = _progress;
          var enrichedData = this.enrichDataWithWatchtime(this.analyticsData, player, "rtl_player_playing");
          this.sendGoogleEvent("rtl_player_playing", enrichedData);
        }
        return;
      }

      // Non livestream also all 5% en rtl_player_progress event

      // let progress = Math.round(player.currentTime / player.duration * 100);
      // progress = progress - (progress % this.percentBreakpoint);

      // // console.log("progress", progress, this.lastProgress, this.percentBreakpoint)
      // // console.log("player", player.currentTime, player.duration)

      // if (progress >= this.lastProgress + this.percentBreakpoint) {
      //     this.lastProgress = progress;

      //     let enrichedData = this.enrichDataWithWatchtime(this.analyticsData, player, "rtl_player_progress");
      //     this.sendGoogleEvent("rtl_player_progress", enrichedData);

      //     if (progress >= 100) {
      //         let enrichedData = this.enrichDataWithWatchtime(this.analyticsData, player, "rtl_player_complete");
      //         this.sendGoogleEvent("rtl_player_complete", enrichedData);
      //     }
      // }

      // Non livestream also all 5% en rtl_player_progress event
      var timeWatchedAll = this.calculateMODTotalTimeWatched(player);
      console.log("SENDING timeWatchedAll", timeWatchedAll, player.duration);
      var progress = Math.round(timeWatchedAll / player.duration * 100);
      progress = progress - progress % this.percentBreakpoint;
      if (progress >= this.lastProgress + this.percentBreakpoint) {
        this.lastProgress = progress;
        var _enrichedData = this.enrichDataWithWatchtime(this.analyticsData, player, "rtl_player_progress");
        this.sendGoogleEvent("rtl_player_progress", _enrichedData);
        if (progress >= 100) {
          var _enrichedData2 = this.enrichDataWithWatchtime(this.analyticsData, player, "rtl_player_complete");
          this.sendGoogleEvent("rtl_player_complete", _enrichedData2);
        }
      }
    }
  }, {
    key: "enrichDataWithWatchtime",
    value: function enrichDataWithWatchtime(data, player, eventName) {
      var newData = _objectSpread({}, data);
      var isLive = !isFinite(player.duration);
      if (isLive) {
        if (eventName === "rtl_player_end") {
          newData["rtl_mm_watch_time"] = Math.ceil(this.totalViewingTime);
        } else {
          newData["rtl_mm_watch_livestream_progress"] = Math.floor(this.lastProgress);
        }
        return newData;
      }
      var timeWatchedAll = this.calculateMODTotalTimeWatched(player);
      if (eventName === "rtl_player_end") {
        newData["rtl_mm_watch_time"] = Math.round(timeWatchedAll);
        newData["rtl_mm_watch_time_with_replay"] = Math.ceil(this.totalViewingTime);
      }
      if (timeWatchedAll) {
        // console.log("TIMEWATCHED ALL", timeWatchedAll, player.currentTime)
        var progress = Math.round(timeWatchedAll / player.duration * 100);
        progress = progress - progress % this.percentBreakpoint;
        newData["rtl_mm_watch_mod_progress"] = `${progress}`;
      }
      return newData;
    }
  }, {
    key: "_fetchData",
    value: function () {
      var _fetchData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var matchAPI, resp, pubResp, inStream, inSummary;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              matchAPI = `${this.location}/api/sport-v3/matches/${this.matchid}?lang=lu`;
              _context3.next = 3;
              return fetch(matchAPI).then(function (resp) {
                return resp.json();
              }).catch(function (e) {
                console.log(e);
                return;
              });
            case 3:
              resp = _context3.sent;
              this.match = resp;
              if (resp) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return");
            case 7:
              _context3.next = 9;
              return fetch("https://europe-west1-aisw-ww-prod.cloudfunctions.net/api_skyhook_v2_beta/page/video", {
                method: 'POST',
                headers: {
                  "Content-type": "application/json"
                },
                body: JSON.stringify({
                  "tenantId": "staige",
                  "id": String(resp.live_arena_id)
                }),
                redirect: 'follow'
              }).then(function (response) {
                return response.json();
              });
            case 9:
              pubResp = _context3.sent;
              inStream = (pubResp.ads || []).filter(function (ad) {
                return ad && ad.inStream && ad.instreamType !== undefined;
              });
              inSummary = (pubResp.ads || []).filter(function (ad) {
                return ad && ad.inSummary && ad.instreamType !== undefined;
              });
              this.sponsors = {
                inStreamElement: inStream,
                inSummaryElement: inSummary
              };
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _fetchData() {
        return _fetchData2.apply(this, arguments);
      }
      return _fetchData;
    }()
  }, {
    key: "_fullscreenEnterEvent",
    value: function _fullscreenEnterEvent(e) {
      console.log("AISW PLAYER", "Enter Fullscreen");
      var isIos = detect.isIOS();
      var isSafari = detect.isSafari();
      if (isIos && isSafari && !window.rtlsites.config.isIosApp) {
        var _parent;
        console.log("Sending toggle Fullscreen Message");
        (_parent = parent) === null || _parent === void 0 || _parent.postMessage({
          type: 'TOGGLE_FULLSCREEN'
        }, '*');
      }
      if (window.rtlsites.config.isIosApp) {
        window.webkit.messageHandlers.fullscreen.postMessage(true);
        document.querySelector("body").style.overflow = "hidden";
      }
    }
  }, {
    key: "_fullscreenExitEvent",
    value: function _fullscreenExitEvent(e) {
      console.log("AISW PLAYER", "Exit Fullscreen");
      var isIos = detect.isIOS();
      var isSafari = detect.isSafari();
      if (isIos && isSafari && !window.rtlsites.config.isIosApp) {
        var _parent2;
        console.log("Sending toggle Fullscreen Message");
        (_parent2 = parent) === null || _parent2 === void 0 || _parent2.postMessage({
          type: 'TOGGLE_FULLSCREEN'
        }, '*');
      }
      if (window.rtlsites.config.isIosApp) {
        window.webkit.messageHandlers.fullscreen.postMessage(false);
        document.querySelector("body").style.overflow = "visible";
      }
    }
  }, {
    key: "render",
    value: function render() {
      //if (!this.match) return null;

      return html(_t || (_t = _`
            <div>
                <style>${0}</style>
                <div class="live-arena__player" id="player-container"></div>
            </div>
        `), css);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        match: {
          type: String
        },
        matchid: {
          type: String
        },
        noautoplay: {
          type: Boolean
        },
        test: {
          type: Boolean
        },
        matchData: {
          type: Object
        }
      };
    }
  }]);
  return RTLLiveArenaPlayer;
}(LitElement);
export { RTLLiveArenaPlayer as default };
window.customElements.define('rtl-live-arena-player', RTLLiveArenaPlayer);